/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import {
    Container, Box, Grid, Typography,
} from '@mui/material';
import { styled } from '@mui/system';

import KPI from '../../Charts/KPI';
import Pie from '../../Charts/Pie';
import Bar from '../../Charts/Bar';
import StackedBar from '../../Charts/StackedBar';

import Filters from '../Filters';

const DashboardWrapper = styled(Box, {})(({ theme }) => ({
    // width: '100%',
    // height: 'calc(100% - 38px)',
    // position: 'relative',
    // paddingTop: 10,
    // paddingBottom: 10,
    // paddingRight: 20,
    // paddingLeft: 20,
    // top: '38px',
    // width: '100%',
    // height: '100%',
}));

const Dashboard = ({ enteringIndex, fullpageApi, percentageChecked }) => {
    const next = () => {
        fullpageApi.moveSectionDown();
    };
    return (
        <DashboardWrapper>

            <Container maxWidth="xl">
                <Grid container spacing={2}>
                    <Grid item sm={12}>
                        <KPI options={{
                            title: 'Number of Respondents',
                            measure: 'Count(Distinct respid)',
                        }}
                        />
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <Pie
                          title="Respondents by Country"
                          options={{
                                dimension: 'Respondent Country',
                                measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
                            }}
                        />
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <Pie
                          title="Does your Organisation use SAP's ERP Software?"
                          options={{
                                dimension: 'Does your organisation use SAP’s ERP software?',
                                measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
                            }}
                        />
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <StackedBar
                          title="Respondents by Position"
                          options={{
                                dimension: 'Respondent Country',
                                dimensionStack: 'Position',
                                measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
                                measureAlt: 'Count(Distinct respid)',
                                sortDir: 'asc',
                            }}
                          percentageChecked={percentageChecked}
                        />
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <StackedBar
                          title="Respondents by Organisation Size"
                          options={{
                                dimension: 'Respondent Country',
                                dimensionStack: 'Organisation Size',
                                measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
                                measureAlt: 'Count(Distinct respid)',
                                sortBy: 'dimension',
                                sortDir: 'asc',
                            }}
                          percentageChecked={percentageChecked}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <StackedBar
                          title="Respondents by Organisation Sector"
                          options={{
                                dimension: 'Respondent Country',
                                dimensionStack: 'Organisation Sector',
                                measure: 'Count(Distinct respid)/Count(Total Distinct respid)',
                                measureAlt: 'Count(Distinct respid)',
                                sortDir: 'desc',
                            }}
                          percentageChecked={percentageChecked}
                          height="450px"
                        />
                    </Grid>
                </Grid>

            </Container>
        </DashboardWrapper>
    );
};

Dashboard.propTypes = {
    enteringIndex: PropTypes.number,
    fullpageApi: PropTypes.object,
    percentageChecked: PropTypes.bool,
};

Dashboard.defaultProps = {
    enteringIndex: 0,
    fullpageApi: {},
    percentageChecked: true,
};

export default Dashboard;
